import { bottomWhiteSpace } from '@/constants'
import { Contract as ContractType, Program as ProgramType, Rebate as RebateType } from '@domain'
import { Paper, Stack, Typography } from '@mui/material'
import Contract from '@views/MarketBaskets/Programs/components/Contract'
import Rebate from '@views/MarketBaskets/Programs/components/Rebate'
import { BooleanParam, useQueryParam } from 'use-query-params'

export default function Program({ program }: { program: ProgramType }) {
	const [isMatchedProduct] = useQueryParam('isMatchedProduct', BooleanParam)

	return (
		<Paper
			variant="outlined"
			sx={{
				color: 'text.primary',
				padding: '1rem',
				width: '100%',
				pb: bottomWhiteSpace,
			}}
		>
			<Stack spacing={2} sx={{ width: '100%' }}>
				<Stack spacing={2}>
					<Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
						<Stack spacing={1} direction="row" sx={{ alignItems: 'center' }}>
							<Typography variant="h4">{program.programType}</Typography>
						</Stack>
					</Stack>
				</Stack>

				<Stack spacing={2} direction="row" sx={{ alignItems: 'flex-start', width: '100%' }}>
					<Contracts contracts={program.contracts} disableSelection={!isMatchedProduct} />
					<Rebates rebates={program.rebates} disableSelection={!isMatchedProduct} />
				</Stack>
			</Stack>
		</Paper>
	)
}

function Contracts({
	contracts,
	disableSelection,
}: {
	contracts: ContractType[]
	disableSelection: boolean
}) {
	return (
		<Stack spacing={2} sx={{ alignItems: 'align-start', width: '100%' }}>
			<Typography variant="h5">Contract Price Savings</Typography>
			{contracts.map((contract) => (
				<Contract key={contract.id} contract={contract} disableSelection={disableSelection} />
			))}
		</Stack>
	)
}

function Rebates({
	rebates,
	disableSelection,
}: {
	rebates: RebateType[]
	disableSelection: boolean
}) {
	return (
		<Stack spacing={2} sx={{ alignItems: 'align-start', width: '100%' }}>
			<Typography variant="h5">Rebates</Typography>
			{rebates.map((rebate) => (
				<Rebate key={rebate.id} rebate={rebate} disableSelection={disableSelection} />
			))}
		</Stack>
	)
}
